export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/accessories.dde32ab.svg";